import React from 'react'
import { useInView } from 'react-intersection-observer'
import cx from 'classnames'

import Mustard from 'images/logos/mustard.svg'
import QVC from 'images/logos/qvc.svg'
import Spiritune from 'images/logos/spiritune.svg'
import Betql from 'images/logos/betql.svg'
import Creatively from 'images/logos/creatively.svg'
import BlackRifle from 'images/logos/brcc.svg'
import Alkeme from 'images/index/alkeme-white.svg'
import Moe from 'images/logos/moe.svg'
import AliceAndOlivia from 'images/logos/aliceolivia.svg'
import TonyRobbins from 'images/logos/tonyrobbins.svg'

const LogoSection = () => {
  const { ref: layoutRef, inView } = useInView({
    triggerOnce: true,
  })

  return (
    <div
      ref={layoutRef}
      className={cx('footer__logo-layout', {
        '--active': inView,
      })}
    >
      <div className="footer__logo-row">
        <div className="footer__logo-item footer__logo-item-0">
          <Mustard className="footer__logo-image --mustard" />
        </div>
        <div className="footer__logo-item footer__logo-item-1">
          <QVC className="footer__logo-image --qvc" />
        </div>
        <div className="footer__logo-item footer__logo-item-2">
          <Spiritune className="footer__logo-image --spiritune" />
        </div>
        <div className="footer__logo-item footer__logo-item-3">
          <Betql className="footer__logo-image --betql" />
        </div>
        <div className="footer__logo-item footer__logo-item-4">
          <Creatively className="footer__logo-image --creatively" />
        </div>
        <div className="footer__logo-item footer__logo-item-5">
          <BlackRifle className="footer__logo-image --impactwayv" />
        </div>
        <div className="footer__logo-item footer__logo-item-6">
          <Alkeme className="footer__logo-image --alkeme" />
        </div>
        <div className="footer__logo-item footer__logo-item-7 --moe">
          <Moe className="footer__logo-image --moe" />
        </div>
        <div className="footer__logo-item footer__logo-item-8">
          <AliceAndOlivia className="footer__logo-image --ao" />
        </div>
        <div className="footer__logo-item footer__logo-item-9">
          <TonyRobbins className="footer__logo-image --tony-robbins" />
        </div>
      </div>
    </div>
  )
}

export default LogoSection
